export // Array of Egyptian cities
const egyptCities = [
  "Cairo",
  "Alexandria",
  "Giza",
  "Shubra El Kheima",
  "Port Said",
  "Suez",
  "Luxor",
  "Aswan",
  "Tanta",
  "Asyut",
  "Ismailia",
  "Faiyum",
  "Zagazig",
  "Damietta",
  "Assiut",
  "Minya",
  "Qena",
  "Beni Suef",
  "Sohag",
  "Hurghada",
  "Shibin El Kom",
  "Banha",
  "Kafr el-Sheikh",
  "Damanhur",
  "Mansoura",
  "El Mahalla El Kubra",
  "New Cairo",
  "6th of October City",
  "10th of Ramadan City",
  "Marsa Matruh",
  "Helwan",
  "Al Arish",
  "Sharm El Sheikh",
  "Dahab",
  "El Alamein",
  "Edfu",
  "Kom Ombo",
  "Mersa Matruh",
  "New Valley",
  "Red Sea",
  "Siwa Oasis",
  "Sadat City",
  "Badr City",
  "New Borg El Arab",
];

// List of Universities
export const universityOptions = [
  "6th October University",
  "Abroad Universities",
  "Ahram Canadian University - ACU",
  "Ain Shams University",
  "Akhbar Elyoum Academy",
  "Al Salam University",
  "Alexandria Private University",
  "Alexandria University",
  "Al-Hayah University",
  "Al - Riyada University for Science and Technology",
  "Al - Salehiya New University",
  "American University in Cairo",
  "Arab Academy for Banking and Financial Sciences",
  "Arab Academy for Science, Technology and Maritime Transport",
  "Arab Open University in Cairo",
  "Arish University",
  "Assiut Private University",
  "Assiut University",
  "Aswan University",
  "Badr University in Assiut",
  "Badr University in Cairo - BUC",
  "Badya University",
  "Benha Private University",
  "Benha University",
  "Beni Suef Private University",
  "Beni Suef University",
  "Berlin Technical University in El Gouna",
  "British University in Egypt - BUE",
  "Cairo University",
  "Canadian International College",
  "City University of Cairo",
  "Damanhour University",
  "Damietta University",
  "Delta University for Science and Technology - Mansoura",
  "Deraya University",
  "East Port Said Private University",
  "Egyptian Chinese University",
  "Egyptian E-learning University",
  "Egyptian Russian University",
  "Egypt-Japan University of Science and Technology",
  "El Alamein International University",
  "El Salehey El Gadida University",
  "El-Azhar University",
  "El Sewedy University of Technology",
  "ESLSCA University Egypt",
  "European Universities in Egypt",
  "Fayoum University",
  "French University in Egypt",
  "Future University In Egypt",
  "German International University",
  "German University in Cairo",
  "Global Academic Foundation",
  "Heliopolis University",
  "Helwan Private University",
  "Helwan University",
  "Herfordshire University",
  "Horus University",
  "Hurghada University",
  "Innovation University",
  "Institute of Arab Research and Studies",
  "Kafr El Sheikh University",
  "King Salman International University",
  "Lotus University",
  "Lotus University in Minya",
  "Luxor University",
  "Madina University in Cairo",
  "Mansoura Private University",
  "Mansoura University",
  "Matrouh University",
  "Mayo University",
  "Menoufia Private University",
  "Menoufia University",
  "Merit University",
  "Minya Private University",
  "Minya University",
  "Misr International University - MIU",
  "Misr University for Informatics",
  "Misr University for Science and Technology",
  "Modern Academy",
  "Modern University for Technology & Information - MTI",
  "Nahda University in Beni Seuif - NUB",
  "New Giza University",
  "New Ismailia Private University",
  "Knowledge Hub Universities",
  "New Mansoura University",
  "New Valley University",
  "Nile University",
  "Nile Valley University",
  "October University for Modern Sciences and Arts - MSA",
  "Others",
  "Pharos University in Alexandria",
  "Port Said University",
  "Prince Edward University",
  "Ryerson University (formerly Ryerson Polytechnic University)",
  "Sadat Academy",
  "Salam University",
  "Senghor University",
  "Sinai University",
  "Sohag University",
  "South Valley Private University",
  "South Valley University",
  "Sphinx University",
  "Suez Canal University",
  "Suez University",
  "Tanta University",
  "University of Galala",
  "University of Sadat City",
  "Zagazig Private University",
  "Zagazig University",
  "Zewail City of Science and Technology and Innovation",
];

// List of Majors
export const majorOptions = [
  "Accounting",
  "Actuarial Science",
  "Aerospace Engineering",
  "Anthropology",
  "Architectural Engineering",
  "Architecture",
  "Astronomy",
  "Biochemistry",
  "Biology (e.g., Ecology, Marine Biology, Microbiology)",
  "Biomedical Engineering",
  "Business Administration",
  "Chemical Engineering",
  "Chemistry",
  "Civil Engineering",
  "Classics",
  "Commerce",
  "Communication Studies",
  "Computer Engineering",
  "Computer Science",
  "Criminology",
  "Cybersecurity",
  "Dentistry: Oral Surgery, Orthodontics",
  "Earth Sciences (e.g., Geology, Meteorology)",
  "Economics",
  "Electrical Engineering",
  "English (Literature, Writing)",
  "Film Studies",
  "Finance",
  "Fine Arts (e.g., Painting, Sculpture)",
  "Geography",
  "Graphic Design",
  "History",
  "Human Resources",
  "Information Systems",
  "Information Technology",
  "Insurance & Risk Management",
  "Interior Design",
  "International Relations",
  "Languages (e.g., Spanish, French, Chinese)",
  "Management",
  "Marketing",
  "Mass Communication",
  "Mathematics",
  "Mechanical Engineering",
  "Mechatronics Engineering",
  "Medicine (pre-med)",
  "Nursing",
  "Networks",
  "Occupational Therapy",
  "Performing Arts (e.g., Music, Theater, Dance)",
  "Petroleum Engineering",
  "Pharmacy",
  "Philosophy",
  "Physical Therapy",
  "Physics",
  "Political Science",
  "Psychology",
  "Public Health",
  "Religious Studies",
  "Social Work",
  "Sociology",
  "Software Engineering",
  "Another option",
  "Other",
];

// Graduation Years from 2020 to 2033
export const gradYearOptions = Array.from({ length: 14 }, (_, i) => 2020 + i);

// Gender Options
export const genderOptions = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
];
